import pf from "../old/pf";
import m from "mithril";
export default () => {
	let count = 0;
	const config = {
		loading: true,
		settingup: true,
		cache: {},
		pagenum: 1,
		sort: {},
		search: {},
	};

	async function GetData() {
		count++;
		config.loading = true;
		m.redraw();
		let data = await RunAPI();
		if (data) config.data = data;
		config.settingup = false;
		config.loading = false;
		m.redraw();
	}

	async function RunAPI() {
		return await pf
			.APIAction(
				"GetBlockDataStandard",
				{
					tid: config.tid,
					tact: config.tact,
					prid: config.prid,
					search: config.colsearch || {},
					category: config.category,
					sort: config.colsort || {},
					groups: config.groups,
					paginate: config.paginate,
					pagesize: config.paginate ? -1 : config.pagesize,
					pagenum: config.pagenum ? 1 : config.pagenum,
					textonly: true,
				},
				function (xhr) {
					config.searchXHR = xhr;
					// console.log("xhr", searchXHR);
				}
			)
			.then((r) => {
				if (r && r.cols.length > 0)
					return {
						cols: r.cols,
						rows: r.rows,
						count: r.count,
					};
				else return null;
			});
	}

	return {
		Initiate: async (tid, tact, prid, category, groups, paginate, pagesize) => {
			Object.assign(config, {tid, tact, prid, category, groups, pagesize, paginate});
			m.redraw();
			await GetData();
		},
		get settingup() {
			return config.settingup;
		},
		get loading() {
			return config.loading;
		},
		get data() {
			return config.data;
		},
		Reset: async () => {
			config.sort = {};
			config.search = {};
			config.pagenum = 1;
			await GetData();
		},
		SetPage: (pagenum) => {},
		SetSort: (col) => {},
		SetSearch: (col, val) => {},
	};
};
